/**
 * Demo mode configuration.
 * When the Demo Workspace feature flag is on, localStorage tracks whether the
 * user is currently inside the isolated demo sandbox vs production tenant UI.
 */
import { isDemoFeatureAllowed } from '../config/featureFlags';

export const DEMO_MODE = false;

export const DEMO_STORAGE_KEY = 'gati_demo_mode';

export function isDemoMode(): boolean {
  if (!isDemoFeatureAllowed()) {
    return false;
  }
  if (typeof window === 'undefined') {
    return DEMO_MODE;
  }
  const stored = localStorage.getItem(DEMO_STORAGE_KEY);
  if (stored !== null) {
    return stored === 'true';
  }
  return DEMO_MODE;
}

export function setDemoMode(enabled: boolean): void {
  if (!isDemoFeatureAllowed()) {
    localStorage.setItem(DEMO_STORAGE_KEY, 'false');
    window.dispatchEvent(new CustomEvent(DEMO_MODE_CHANGE_EVENT));
    return;
  }
  localStorage.setItem(DEMO_STORAGE_KEY, enabled ? 'true' : 'false');
  window.dispatchEvent(new CustomEvent(DEMO_MODE_CHANGE_EVENT));
}

export const DEMO_MODE_CHANGE_EVENT = 'gati-demo-mode-change';
